import React from "react";
import { Link } from "react-router-dom";

import AddOrgButton from "@LeagueManagement/Organizations/components/AddOrgButton";
import PendingApprovalAlert from "@LeagueManagement/Organizations/components/PendingApprovalAlert";
import { useOrganizationsContext } from "@LeagueManagement/Organizations/contexts/OrganizationsContext";

const OrgIndex = (): React.JSX.Element => {
    const { organizations, pendingApproval } = useOrganizationsContext();

    return (
        <div className="organizationsContent">
            {pendingApproval.length > 0 && (
                <PendingApprovalAlert pendingApproval={pendingApproval} />
            )}

            <AddOrgButton />

            {organizations.map(o => (
                <section className="organization" key={o.id}>
                    <div className="orgLeft">
                        <h4>
                            <Link to={`edit/${o.id}`}>{o.name}</Link>
                        </h4>
                        <div className="orgUserInfo">
                            <b>{o.primaryUser.name}</b>
                            <br />
                            {o.primaryUser.email}
                            <br />
                            {o.primaryUser.phoneNumbers.primary} (primary)
                            <br />
                            {o.primaryUser.phoneNumbers.secondary &&
                                `${o.primaryUser.phoneNumbers.secondary} (secondary)<br />`}
                            {o.primaryUser.phoneNumbers.other &&
                                `${o.primaryUser.phoneNumbers.other} (other) <br />`}
                        </div>
                    </div>
                    <div className="orgRight">
                        <div>
                            <b>Teams</b>
                            <ul>
                                {o.teams.map(t => (
                                    <li key={`team-${t.id}`}>
                                        {t.name} ({t.ageLevel})
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>
            ))}
        </div>
    );
};

export default OrgIndex;
